import { Box, useTheme } from '@mui/material';
import PropTypes from 'prop-types';

export const TrlSpacer = ({ width }) => {
  const theme = useTheme();

  return (
    <Box
      width={width ?? theme.spacing(3)}
      minWidth={width ?? theme.spacing(3)}
      maxWidth={width ?? theme.spacing(3)}
    />
  );
};

TrlSpacer.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
